import React, { useEffect, useState } from "react";
import { fetchWithAuth } from "../../utils/api";
import "./MessagesMenu.css";

/**
 * The photos (or video, audio, PDF) a customer texted with a message, fetched
 * from Twilio through the server (GET /v1/customer-texts/:id/media/:n — the
 * same people who may read the text) and shown from memory: the token stays
 * in the request header, never in a link. Used by the top bar's Messages
 * panel and the order's message panel (modals/MessageSidebar.js).
 */
export default function TextPhotos({ messageId, count }) {
  const [files, setFiles] = useState([]); // [{ url, type } | { failed: true }]

  useEffect(() => {
    if (!messageId || !count) return undefined;
    let live = true;
    const made = [];
    (async () => {
      const out = [];
      for (let n = 0; n < Math.min(count, 10); n += 1) {
        try {
          const res = await fetchWithAuth(`/v1/customer-texts/${messageId}/media/${n}`);
          if (!res.ok) { out.push({ failed: true }); continue; }
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          made.push(url);
          out.push({ url, type: blob.type });
        } catch {
          out.push({ failed: true });
        }
      }
      if (live) setFiles(out);
    })();
    return () => {
      live = false;
      made.forEach((u) => URL.revokeObjectURL(u));
    };
  }, [messageId, count]);

  if (!count) return null;
  if (!files.length) return <p className="msg-photos-note">Loading {count === 1 ? "the photo" : `${count} photos`}…</p>;
  return (
    <div className="msg-photos">
      {files.map((f, i) => {
        // eslint-disable-next-line react/no-array-index-key
        if (f.failed) return <span key={i} className="msg-photo-missing">Photo couldn&apos;t be loaded</span>;
        const open = () => window.open(f.url, "_blank", "noopener");
        if (f.type.startsWith("image/")) {
          // eslint-disable-next-line react/no-array-index-key
          return <button key={i} type="button" className="msg-photo" onClick={open} aria-label="Open the photo"><img src={f.url} alt="What the customer texted" /></button>;
        }
        if (f.type.startsWith("video/")) {
          // eslint-disable-next-line react/no-array-index-key, jsx-a11y/media-has-caption
          return <video key={i} className="msg-photo" src={f.url} controls preload="metadata" />;
        }
        // eslint-disable-next-line react/no-array-index-key
        return <button key={i} type="button" className="btn btn-secondary btn-sm" onClick={open}>Open the file</button>;
      })}
    </div>
  );
}
